import { useQuery } from '@tanstack/react-query';

import { getCampaigns } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { CampaignStatus } from 'modules/campaigns/types';

import { CampaignsQueryKeys } from '../campaignsQueryKeys';
import { useCampaignModuleContext } from '../context';
import { transformCampaignApiToCampaignListItem } from '../utils/transformApiCampaignToCampaignListItem/transformApiCampaignToCampaignListItem';

export const useCampaignsList = ({
  merchantId,
  venueIds,
  status,
  timezone,
  country,
  isMerchantLevel,
  enabled,
}: {
  merchantId: string;
  venueIds?: string[];
  status?: readonly Exclude<CampaignStatus, CampaignStatus.STOPPED>[];
  timezone: string;
  country: Country;
  isMerchantLevel: boolean;
  enabled: boolean;
}) => {
  const { currency } = useCampaignModuleContext();

  const {
    data: campaignsList = [],
    isFetching: isCampaignsLoading,
    isError: isCampaignsError,
  } = useQuery(
    CampaignsQueryKeys.GET_ALL(merchantId, venueIds),
    () =>
      getCampaigns({
        merchantId,
        venueIds,
        status,
      }),
    {
      select: ({ results }) =>
        results.map(campaign =>
          transformCampaignApiToCampaignListItem(campaign, timezone, country, currency, isMerchantLevel),
        ),
      refetchOnWindowFocus: false,
      enabled: enabled && !!merchantId,
      retry: false,
    },
  );
  return { campaignsList, isCampaignsLoading, isCampaignsError };
};
